var $3a49d121fe4c9e1d$exports = {};
$3a49d121fe4c9e1d$exports = {
  "calendar": "Takvim",
  "day": "g\xFCn",
  "dayPeriod": "\xD6\xD6/\xD6S",
  "endDate": "Biti\u015F Tarihi",
  "era": "\xE7a\u011F",
  "hour": "saat",
  "minute": "dakika",
  "month": "ay",
  "second": "saniye",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Se\xE7ilen Tarih: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Se\xE7ilen Aral\u0131k: ".concat(args.startDate, " - ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Se\xE7ilen Zaman: ".concat(args.time);
  },
  "startDate": "Ba\u015Flang\u0131\xE7 Tarihi",
  "timeZoneName": "saat dilimi",
  "weekday": "haftan\u0131n g\xFCn\xFC",
  "year": "y\u0131l"
};
export { $3a49d121fe4c9e1d$exports as default };